import { TestId as _TestId } from './src/testIds';
export type TestId = _TestId;

export {
  HeaderTestIds,
  CreateBoardTestIds,
  HomeTestIds,
  NavigationTestIds,
  NotificationTestIds,
  PowerUpTestIds,
  TeamTestIds,
  CreateFirstBoardIds,
  PopoverTestIds,
  BillingIds,
  PurchaseFormIds,
  MoonshotTestIds,
  SlackCodesTestIds,
  CardBackTestIds,
  BoardHeaderTestIds,
  EnterpriseDashboardTestIds,
  OrganizationViewTestIds,
  SelectTestIds,
  FreeTrialTestIds,
  ChecklistTestIds,
  ProfileTestIds,
  WorkSpacesPreambleTestIds,
  BCTeamOnboardingTestIds,
  UpgradePromptTestIds,
  BadgesTestIds,
  CanonicalCard,
  BoardReportsViewTestIds,
  TEST_ID_ATTR,
  TEST_ID_SELECTOR,
  FreeTeamOnboardingTestIds,
  TableTestIds,
  AdvCalendarTestIds,
  TimelineTestIds,
  WorkspaceNavigationTestIds,
  WorkspaceSwitcherTestIds,
  MigrationWizardTestIds,
  ViewHeaderTestIds,
  DateRangePickerTestIds,
  CardTemplateTestIds,
  TemplatesTestIds,
  ShortcutsPageTestIds,
} from './src/testIds';
